import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'includeSelected',
    pure: false,
    standalone: false
})
export class IncludeSelectedPipe implements PipeTransform {
  transform(allOptions: string[], selectedOptions: string[]): string[] {
    return allOptions.filter(option => selectedOptions.includes(option));
  }
}
